const getInquiringProviderUserName = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business
    && business['Company Info']
    && business['Company Info']['Signer First Name']
    && business['Company Info']['Signer Last Name']) {
    return `${business['Company Info']['Signer First Name']} ${business['Company Info']['Signer Last Name']}`;
  }
  return null;
};

export default getInquiringProviderUserName;



// WEBPACK FOOTER //
// ./src/utils/print/getInquiringProviderUserName.js